<div class="container-fluid spacer-top-navigation">
  <div class="container">
    <ng-container *ngTemplateOutlet="(isPotentialCustomer$ | async) ? guidedTourBeforeOpening : homePage" />
  </div>
</div>

<ng-template #homePage>
  <guided-tour />
  <home-depot-header
    [isPerformanceReady]="(positionsFacade.performanceReady$ | async) || !!(positionsFacade.positionsLoadingError$ | async)"
    [performance]="positionsFacade.portfolioPerformance$ | async"
    (customerIsWaitingForOpening)="shouldDisplaySovendusIntegration = true"
  />

  @if ((contractConfirmationFacade.contractConfirmations$ | async)?.length) {
    <shared-contract-confirmation-reminder />
  }

  @if (lombardFacade.shouldDisplayConfirmationModal$ | async) {
    <lombard-confirmation-reminder />
  }

  <div class="row">
    <div class="col-12">
      @if (customerStateFacade.customerAccountData$ | async; as customerAccount) {
        @if (customerAccount?.overdrawn && !negativeAmountAlertClosed) {
          <ngb-alert
            type="danger"
            (close)="negativeAmountAlertClosed = true"
            [innerHTML]="'my-home.my-home-page.negative-amount-alert' | transloco"
          />
        }
        @if (customerAccount?.lastImportedSaldo === 0 && !showIbanAlertClosed) {
          <ngb-alert
            type="info"
            (close)="showIbanAlertClosed = true"
            [innerHTML]="'my-home.my-home-page.iban-alert' | transloco: { iban: customerAccount.accountIban | formateIban }"
          />
        }
      }
      <bezugsrecht-announcement-list />

      <web-components-user-notes target="depotoverview" [dismissibleNotes]="true" [notifyLoadedNotesCount$]="userNotesLoaded$" />

      @if (showAdAgreeNote) {
        <home-ad-agree-note (hideNote)="showAdAgreeNote = false" />
      }
    </div>
  </div>

  <div class="row same-height">
    <div class="col-lg-4 mb-4 mb-lg-0">
      <div class="tile">
        <home-my-market-overview data-zid="market-overview" />
      </div>
    </div>
    <div class="col-lg-4 mb-4 mb-lg-0">
      <div class="tile">
        <home-my-top-instruments data-zid="top-products" />
      </div>
    </div>
    <div class="col-lg-4 mb-4 mb-lg-0">
      <div class="tile">
        <discover-card />
      </div>
    </div>
  </div>
  <div class="spacer-default hidden-xs hidden-sm hidden-md"></div>

  @if (depotFacade.dividendReinvestHint$ | async) {
    <shared-dividend-re-invest-hint type="home" />
  }

  @if (lombardFacade.shouldDisplayTeaser$ | async) {
    <lombard-teaser />
  }

  <depot-first-savings-plan-teaser />

  @if (shouldDisplaySovendusIntegration) {
    <home-sovendus />
  }
  <div class="row">
    <div class="col-12">
      <div class="tile">
        <home-positions
          [isLoading]="positionsFacade.positionsLoading$ | async"
          [positions]="positionsFacade.positions$ | async"
          data-zid="positions"
        />
      </div>
    </div>
  </div>
  @if (showCryptos$ | async) {
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <home-cryptos [positions]="positionsFacade.cryptos$ | async" data-zid="cryptos" />
        </div>
      </div>
    </div>
  }

  <home-multi-order-strategies-slider />

  <div class="row">
    <div class="col-12">
      <div class="tile">
        <order-zero-orders (reloadPositions)="reloadPositions()" data-zid="orders" />
      </div>
    </div>
  </div>
</ng-template>

<ng-template #guidedTourBeforeOpening>
  <guided-tour-teaser />
</ng-template>
